module.exports = __webpack_public_path__ + "static/media/PromptConfirm.fff3ccc6.svg";